import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { HelpService } from '~commonInfra/services/HelpService';

import { Messages } from '../../../codegen/Localize';
import { SettingsSection } from '../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../general-settings/components/SettingsComponentRegistryFunctions';
import { learnMoreStyle } from '../../styles/CommonStyles';
import { BridgeSiteSettingsProps } from '../BridgeSiteSettings';
import { BridgeMultiPoolSection } from './bridgeMultiPool/BridgeMultiPoolSection';

export function BridgePoolingSection(props: BridgeSiteSettingsProps) {
  return (
    <SettingsSection title={Messages.bridgeSiteSettingsPooling()}
      testId={'bridge-pooling-section'}
      description={renderDescription()}>
      <BridgeMultiPoolSection
        pools={props.edgePools.userDefinedPools}
        connectionStatuses={props.connectionStatuses}
        siteId={props.settings.id}
        refreshEdgePools={props.refreshEdgePools}
        hasLoadedEdgePools={props.hasLoadedEdgePools}
      />
    </SettingsSection>
  );
}

function renderDescription() {
  return <>
    <span>{Messages.bridgeSiteSettingsPooling_description()}</span>
    <TextLinkWidget testId={'bridge-pooling-learn-more'}
      className={learnMoreStyle}
      href={HelpService.getServerHelpUrlByCategory('bridge-pooling')}
      target={'_blank'}>
      {Messages.siteRemoteAgentSettingsLearnMore()}
    </TextLinkWidget>
  </>;
}

/* for registering the component in settings registry */
export const BridgePoolingSectionSpecs = componentRegistryEntry({
  name: 'BridgePoolingSection',
  component: BridgePoolingSection
});
